import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const styles = ({
  isRecording,
  isPlaying,
  isJoinVideoSurvey,
}: {
  isRecording: boolean;
  isPlaying: boolean;
  isJoinVideoSurvey: boolean;
}) =>
  makeStyles((theme: Theme) => ({
    modal: {
      maxWidth: "730px",
    },
    section: {
      marginTop: isJoinVideoSurvey ? 0 : 40,
      width: "100%",
    },
    modalTitle: {
      font: "800 20px/28px Manrope",
      color: "#232325",
    },
    header: {
      marginTop: isJoinVideoSurvey ? 0 : 35,
    },
    buttonRecord: {
      width: 110,
      backgroundColor: isRecording ? `${theme.palette.error.dark} !important` : "",
    },
    buttonPlay: {
      width: 93,
      backgroundColor: isPlaying ? `${theme.palette.success.dark} !important` : "",
    },
    divider: {
      marginTop: "1rem",
    },
    audioDeviceText: {
      font: "700 18px/18px Manrope",
      color: "#465869",
    },
    deviceTitle: {
      marginBottom: 16,
      color: "#465869",
      font: "700 18px/18px Manrope",
    },
  }));

export default styles;
